import {
  ReferralFilter,
  ReferralStatus,
} from '../../../../../models/graphqlTypes'

export interface PatientReferralsFilter {
  isExisting?: boolean
  isDeleted?: boolean
}

export type ReferralsFilterForDoctor = ReferralFilter & PatientReferralsFilter

const existingStatuses = [
  ReferralStatus.Created,
  ReferralStatus.AppointmentBooked,
  ReferralStatus.Expired,
  ReferralStatus.Finished,
  ReferralStatus.WaitingOnResult,
]
const deletedStatuses = [ReferralStatus.Deleted]

export const getStatusesByReferralStatusFilter = (
  filter: PatientReferralsFilter
): ReferralStatus[] => {
  const statuses: ReferralStatus[] = []
  if (filter.isExisting) {
    statuses.push(...existingStatuses)
  }
  if (filter.isDeleted) {
    statuses.push(...deletedStatuses)
  }
  return statuses
}

export const isReferralDeleted = (referralStatus: ReferralStatus) =>
  deletedStatuses.includes(referralStatus)
